var parent = require('../../../es/array/virtual/for-each');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/array/virtual/for-each.js
// module id = 4829
// module chunks = 25